import axios from 'axios'
import { url } from '../../api/url'
import { HeadersWithCredentials } from '../../api/header'
import { Constants } from '../../utils/Constants'

export const findNextEventOptions = async (competitionId) => {
    return axios.get(`${url}/qualifications/${competitionId}/find-next-event-options`, {
        headers: HeadersWithCredentials(),
    })
}

export const updateSelectedNextEvent = async (competitionId, nextEventId) => {
    return axios.put(
        `${url}/qualifications/${competitionId}/update-selected-next-event`,
        { nextEventId },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

const STATE_VALUES = [
    Constants.QUALIFICATION_STATE.WAITING,
    Constants.QUALIFICATION_STATE.QUALIFIED,
    Constants.QUALIFICATION_STATE.REGISTERED,
    Constants.QUALIFICATION_STATE.DISQUALIFIED,
]
export const ChangeParticipantQualifyState = async (
    competitionId,
    previousLeaderboardId,
    participantId,
    divisionId,
    state,
) => {
    console.log(previousLeaderboardId)
    return axios.put(
        `${url}/qualifications/${competitionId}/qualify/${previousLeaderboardId}/${participantId}/${divisionId}`,
        {
            state: STATE_VALUES.indexOf(state),
        },
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const SyncParticipants = async (competitionId) => {
    return axios.patch(
        `${url}/qualifications/sync-participants/${competitionId}`,
        {},
        {
            headers: HeadersWithCredentials(),
        },
    )
}

export const FixOutdatedParticipants = async (competitionId) => {
    return axios.patch(
        `${url}/qualifications/fix-outdated-participants/${competitionId}`,
        {},
        {
            headers: HeadersWithCredentials(),
        },
    )
}
